import React from "react";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1072_R01Store from "./usePDA1072_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import { usePDA1072_R01Content } from "./PDA1072_R01Content";

import PDA1072_R01Search from "./PDA1072_R01Search";
import PDA1072_R01Table from "./PDA1072_R01Table";
import PDA1072_R01DetailInfo from "./PDA1072_R01DetailInfo";
import PDA1072_R01DetailTable from "./PDA1072_R01DetailTable";

interface PDA1072_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1072_R01Container = ({ menuNm, menuCd, onBack }: PDA1072_R01ContainerProps) => {
  const { loading, reset, showList, workOrderList } = usePDA1072_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);
  const { handleSearch, handleRefetch, handleSelectWorkOrder, handleBackToList } =
    usePDA1072_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={showList ? onBack : handleBackToList}
        onMenuClick={handleMenuClick}
      />

      <div className="flex-1 overflow-hidden">
        {showList ? (
          <div className="h-full flex flex-col">
            <PDA1072_R01Search onSearch={handleSearch} onRefetch={handleRefetch} />
            <div className="flex-1 overflow-hidden">
              <PDA1072_R01Table
                workOrderList={workOrderList}
                onSelectWorkOrder={handleSelectWorkOrder}
              />
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col min-h-0">
            <PDA1072_R01DetailInfo />
            <div className="flex-1 overflow-hidden flex flex-col min-h-0">
              <PDA1072_R01DetailTable />
            </div>
          </div>
        )}
      </div>

      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1072_R01Container;
